import { notifyVatRefresh } from '../utils/vatDisplay';

const initLoadMore = () => {
  const loadMoreEls = document.querySelectorAll('[data-load-more]');
  if (!loadMoreEls.length) return;
  const loadMoreItemsEl = '[data-load-more-items]';

  const initLoadMoreElement = (rootEl) => {
    const itemsCountTextEl = rootEl.querySelector('[data-load-more-count-text]');
    const itemsCountPagedTextEl = itemsCountTextEl?.querySelector('[data-load-more-count-paged]');
    const loadMoreButton = rootEl.querySelector('[data-load-more-button]');
    const loadingSpinner = rootEl.querySelector('[data-loading-spinner]');

    let loading = false;

    const setLoading = (isLoading) => {
      loading = isLoading;
      loadMoreButton?.classList.toggle('loading', isLoading);
      loadingSpinner?.classList.toggle('hidden', !isLoading);
    };

    const loadNextPage = async () => {
      if (!loadMoreButton || loading) return;

      setLoading(true);
      try {
        const response = await fetch(loadMoreButton.href);
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const sectionRoot = rootEl.closest('[data-section-id]');
        const sectionId = sectionRoot?.dataset.sectionId;
        const parsedLoadMoreContainer = sectionId
          ? parsed.querySelector(`[data-section-id="${sectionId}"] ${loadMoreItemsEl}`)
          : parsed.querySelector(loadMoreItemsEl);
        const ogLoadMoreContainer = sectionRoot?.querySelector(loadMoreItemsEl) ?? document.querySelector(loadMoreItemsEl);
        const newLoadMoreEl = parsed.querySelector('[data-load-more]');

        if (!parsedLoadMoreContainer || !ogLoadMoreContainer) return;

        const newItems = [...parsedLoadMoreContainer.children];

        newItems.forEach((child) => ogLoadMoreContainer.append(child.cloneNode(true)));

        // New cards are SSR'd in the default VAT mode; re-apply the visitor's toggle state.
        notifyVatRefresh();

        if (itemsCountPagedTextEl) {
          itemsCountPagedTextEl.textContent = ogLoadMoreContainer.children.length;
        }

        if (newLoadMoreEl) {
          const newButton = newLoadMoreEl.querySelector('[data-load-more-button]');
          if (newButton) loadMoreButton.href = newButton.href;
        } else {
          loadMoreButton.remove();
        }
      } catch (err) {
        console.error('Error during loading products:', err);
      } finally {
        setLoading(false);
      }
    };

    const handleButtonClick = (e) => {
      e.preventDefault();
      loadNextPage();
    };
    loadMoreButton?.addEventListener('click', handleButtonClick);
  };
  loadMoreEls.forEach(initLoadMoreElement);
};

export default initLoadMore;
